import request from '@/utils/request';
export const fileTransferHeaders = {};
export const defaultCategoryData = {
  id: 0,
  enabled: true,
  name: '',
  tallyAlias: '',
  icon: '',
  image: '',
  description: '',
  priority: 0,
  featured: true,
  parent: null,
  bgcolor: null,
  rangeId: null,
  range: {
    id: null
  }
};
export const getCategories = params => request({
  url: '/categories',
  method: 'get',
  params
});
export const getCategoriesList = params => request({
  url: '/categories/list',
  method: 'get',
  params
});
export const getCategoriesTree = () => request({
  url: '/categories/list/tree',
  method: 'get'
});
export const getCategoryById = id => request({
  url: `/categories/${id}`,
  method: 'get'
});
export const updateCategory = (id, data) => request({
  url: `/categories/${id}`,
  method: 'patch',
  data
});
export const deleteCategory = id => request({
  url: `/categories/${id}`,
  method: 'delete'
});
export const createCategory = data => request({
  url: '/categories',
  method: 'post',
  data
});